/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DrugUsageDto
 */
export interface DrugUsageDto {
    /**
     * 
     * @type {number}
     * @memberof DrugUsageDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DrugUsageDto
     */
    'drugOrderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DrugUsageDto
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DrugUsageDto
     */
    'isDifferFromOrder'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DrugUsageDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DrugUsageDto
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrugUsageDto
     */
    'usageDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugUsageDto
     */
    'usagePeriod'?: DrugUsageDtoUsagePeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof DrugUsageDto
     */
    'usageStatus'?: DrugUsageDtoUsageStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DrugUsageDto
     */
    'usageTime'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DrugUsageDtoUsagePeriodEnum {
    Morning = 'MORNING',
    Noon = 'NOON',
    Evening = 'EVENING'
}
/**
    * @export
    * @enum {string}
    */
export enum DrugUsageDtoUsageStatusEnum {
    Done = 'DONE',
    Undone = 'UNDONE',
    Undefined = 'UNDEFINED'
}


